<!-- This is a modified version of `app-playbooks-trigger` component and will eventually replace it when the feature is generally available. -->

<div class="trigger">
  <app-popup-top-line></app-popup-top-line>
  <div class="header">
    <div class="title">{{ 'playbooks.trigger' | labelsProvider }}</div>
    <img src="assets/images/common/cancel.svg" (click)="closeWindow()" />
  </div>
  <div class="separator"></div>
  <div class="content">
    <div class="trigger-type-and-coverage">
      <div>
        <div class="title">
          {{ 'playbooks.trigger' | labelsProvider }}
          {{ 'common.type' | labelsProvider }}
        </div>
        <div class="trigger-options">
          @for (triggerType of triggerTypeOptions; track triggerType) {
            <div
              class="trigger-option"
              [ngClass]="{ selected: selectedTriggerType === triggerType }"
              (click)="typeSelected(triggerType)"
            >
              <div class="trigger-option-title">{{ getTriggerTypeDisplayName(triggerType) }}</div>
            </div>
          }
        </div>
      </div>
      <div class="vertical-separator"></div>
      @if (
        selectedTriggerType !== supportedTriggerTypes.findings && selectedTriggerType !== supportedTriggerTypes.issues
      ) {
        <div>
          <div class="title">
            {{ 'playbooks.coverage' | labelsProvider }}

            <img
              src="assets/images/common/info.svg"
              width="14"
              [matTooltip]="'playbooks.coverageTooltip' | labelsProvider"
              matTooltipPosition="below"
              matTooltipClass="tooltip-container"
            />
          </div>
          <div class="trigger-options">
            @for (triggerCoverage of triggerCoverageOptions; track triggerCoverage) {
              <div
                class="trigger-option"
                [ngClass]="{ selected: selectedTriggerCoverage === triggerCoverage }"
                (click)="coverageSelected(triggerCoverage)"
              >
                <div class="trigger-option-title">{{ triggerCoverage | beautifyDisplayString }}</div>
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="separator"></div>
    @if (selectedTriggerType === supportedTriggerTypes.findings) {
      <div class="findings-policy-info">
        <img src="assets/images/common/info.svg" width="16" />
        <span>{{ 'playbooks.findingsPolicyInfo' | labelsProvider }}</span>
      </div>
    }
    @if (selectedTriggerType === supportedTriggerTypes.issues) {
      <div class="findings-policy-info">
        <img src="assets/images/common/info.svg" width="16" />
        <span>{{ 'playbooks.issuePolicyInfo' | labelsProvider }}</span>
      </div>
    }
    <div class="trigger-settings">
      <div class="title">
        {{ 'playbooks.trigger' | labelsProvider }}
        {{ 'common.settings' | labelsProvider }}
      </div>

      <div class="trigger-settings-content">
        @if (selectedTriggerType === supportedTriggerTypes.violations) {
          <app-new-violation-trigger
            [fg]="fg"
            [playbooksTriggerInput]="triggerFormInput"
            (validConfiguration)="setFormValidation($event)"
            class="new-violation-trigger"
          >
          </app-new-violation-trigger>

          <div class="buttons-container buttons-container-violations">
            <div class="btns">
              <div class="cancel" (click)="closeWindow()">
                {{ 'common.cancel' | labelsProvider }}
              </div>

              @if (isConfigurationValid()) {
                <div class="confirm" (click)="createOrUpdate()" cdkFocusInitial>
                  <span>{{ isEdit ? ('common.save' | labelsProvider) : ('common.create' | labelsProvider) }}</span>
                </div>
              } @else {
                <div class="confirm confirm-disabled" cdkFocusInitial>
                  <span>{{ isEdit ? ('common.save' | labelsProvider) : ('common.create' | labelsProvider) }}</span>
                </div>
              }
            </div>
          </div>
        } @else if (selectedTriggerType === supportedTriggerTypes.resources) {
          <app-new-resource-trigger
            [fg]="fg"
            [playbooksTriggerInput]="triggerFormInput"
            (validConfiguration)="setFormValidation($event)"
            class="new-resource-trigger"
          >
          </app-new-resource-trigger>

          <div class="buttons-container buttons-container-resources">
            <div class="description-tooltip">
              <app-supported-resource-types-tooltip
                [resourceTypeOptions$]="resourceTypeOptions$"
              ></app-supported-resource-types-tooltip>
            </div>

            <div class="btns">
              <div class="cancel" (click)="closeWindow()">
                {{ 'common.cancel' | labelsProvider }}
              </div>
              @if (isConfigurationValid()) {
                <div class="confirm" (click)="createOrUpdate()" cdkFocusInitial>
                  <span>{{ isEdit ? ('common.save' | labelsProvider) : ('common.create' | labelsProvider) }}</span>
                </div>
              } @else {
                <div class="confirm confirm-disabled" cdkFocusInitial>
                  <span>{{ isEdit ? ('common.save' | labelsProvider) : ('common.create' | labelsProvider) }}</span>
                </div>
              }
            </div>
          </div>
        } @else if (selectedTriggerType === supportedTriggerTypes.findings) {
          <app-new-finding-trigger
            [fg]="fg"
            [playbooksTriggerInput]="triggerFormInput"
            [policyIds]="triggerInput.policyIds || []"
            [detectionRules]="detectionRules()"
            (validConfiguration)="setFormValidation($event)"
            class="new-finding-trigger"
          >
          </app-new-finding-trigger>

          <div class="buttons-container buttons-container-findings">
            <div class="btns">
              <div class="cancel" (click)="closeWindow()">
                {{ 'common.cancel' | labelsProvider }}
              </div>
              @if (isConfigurationValid()) {
                <div class="confirm" (click)="createOrUpdate()" cdkFocusInitial>
                  <span>{{ isEdit ? ('common.save' | labelsProvider) : ('common.create' | labelsProvider) }}</span>
                </div>
              } @else {
                <div class="confirm confirm-disabled" cdkFocusInitial>
                  <span>{{ isEdit ? ('common.save' | labelsProvider) : ('common.create' | labelsProvider) }}</span>
                </div>
              }
            </div>
          </div>
        } @else if (selectedTriggerType === supportedTriggerTypes.issues) {
          <app-new-issue-trigger
            [fg]="fg"
            [playbooksTriggerInput]="triggerFormInput"
            (validConfiguration)="setFormValidation($event)"
            class="new-issue-trigger"
          >
          </app-new-issue-trigger>

          <div class="buttons-container buttons-container-issues">
            <div class="btns">
              <div class="cancel" (click)="closeWindow()">
                {{ 'common.cancel' | labelsProvider }}
              </div>
              @if (isConfigurationValid()) {
                <div class="confirm" (click)="createOrUpdate()" cdkFocusInitial>
                  <span>{{ isEdit ? ('common.save' | labelsProvider) : ('common.create' | labelsProvider) }}</span>
                </div>
              } @else {
                <div class="confirm confirm-disabled" cdkFocusInitial>
                  <span>{{ isEdit ? ('common.save' | labelsProvider) : ('common.create' | labelsProvider) }}</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
